module.exports = __webpack_public_path__ + "img/alipay-icon.f20272f4.svg";